export var getFormattedName = function getFormattedName(member) {
  member = member || {};
  var nameArray = [];
  if (member.FirstName) {
    nameArray.push(member.FirstName);
  }
  if (member.LastName) {
    nameArray.push(member.LastName);
  }
  return nameArray.join(' ');
};
export var getMemberBySubscriberId = function getMemberBySubscriberId(householdMembers, subscriberId) {
  householdMembers = householdMembers || [];
  return householdMembers.find(function (member) {
    return member.SubscriberId === subscriberId;
  });
};
export var sortMemberListByAlpheticalOrder = function sortMemberListByAlpheticalOrder(householdMembers, headOfHousehold, includeHoH) {
  var HoH;
  var newList;
  if (headOfHousehold && householdMembers) {
    if (includeHoH) {
      HoH = householdMembers.find(function (item) {
        return item.SubscriberId === headOfHousehold.SubscriberId;
      });
      householdMembers = householdMembers.filter(function (item) {
        return item.SubscriberId !== HoH.SubscriberId;
      });
    }
    newList = householdMembers.sort(function (a, b) {
      a = a.formattedName.toUpperCase();
      b = b.formattedName.toUpperCase();
      if (a < b) {
        return -1;
      }
      if (a > b) {
        return 1;
      }
      return 0;
    });
    return includeHoH ? Array(HoH).concat(newList) : newList;
  }
};

//This will take a group of ratings by category and find the
//value in the ratingPrivileges to display the highest access level for that category
export var findLastSelectedRating = function findLastSelectedRating(ratings, memberRatings) {
  if (ratings && memberRatings) {
    var categoryValues = ratings.map(function (_ref) {
      var Value = _ref.Value;
      return parseInt(Value);
    });
    var applicableMemberRatings = memberRatings.filter(function (item) {
      return categoryValues.includes(item);
    });
    var ratingValue = applicableMemberRatings.reduce(function (prev, next) {
      return prev > next ? prev : next;
    }, null);
    return ratings.find(function (item) {
      return parseInt(item.Value) === ratingValue;
    });
  } else {
    return null;
  }
};